<!-- Ported from the Polaris kit: src/components/ui/table/TableHeader.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <thead
    data-slot="table-header"
    :class="
      cn(
        '[&_tr]:border-b [&_tr]:border-solid [&_tr]:border-polaris-border',
        props.class
      )
    "
  >
    <slot />
  </thead>
</template>
